import { minuteOfDayToTime } from "@/utils/schedule";

export type CombinationSlot = {
  id: number;
  shopId: number;
  shopName: string;
  startMinuteOfDay: number;
};

export type Combination = {
  id: number;
  slots: CombinationSlot[];
};

type Props = {
  combination: Combination;
  onBook: () => void;
  booking?: boolean;
  handleMoveToBuilder: () => void;
};

export default function ScheduleCombinationCard({
  combination,
  onBook,
  booking = false,
  handleMoveToBuilder
}: Props) {
  return (
    <div className="bg-white rounded-2xl p-5 shadow-sm">
      <div className="mb-4">
        {combination.slots.map((slot, slotIndex) => (
          <div key={slot.id || `${slot.shopId}-${slot.startMinuteOfDay}`} className="flex items-start gap-4">
            <div className="flex-shrink-0">
              <span className="text-sm font-bold text-gray-900">
                {minuteOfDayToTime(slot.startMinuteOfDay)}
              </span>
            </div>

            <div
              className="flex flex-col items-center flex-shrink-0"
              style={{ paddingTop: "7px" }}
            >
              <div className="w-3 h-3 rounded-full bg-blue-600"></div>
              {slotIndex < combination.slots.length - 1 && (
                <div className="w-0.5 h-12 bg-blue-200 my-1"  style={{ marginTop: 7}}></div>
              )}
            </div>

            <div className="flex-1 pt-0.5">
              <p className="text-sm font-semibold text-gray-900">
                {slot.shopName}
              </p>
              <p className="text-xs text-gray-500 mt-0.5">1시간 방문</p>
            </div>
          </div>
        ))}
      </div>
      <div className='flex gap-3'>
        <div className='flex-1'>
          <button
            onClick={onBook}
            disabled={booking}
            className={`w-full py-3 font-semibold rounded-xl transition-colors whitespace-nowrap ${
              booking
                ? "bg-gray-300 text-white cursor-not-allowed"
                : "bg-blue-600 text-white hover:bg-blue-700 cursor-pointer"
            }`}
          >
            {booking ? "예약중..." : "이 일정 예약하기"}
          </button>
        </div>
        <div className='flex-1'>
          <button
            type="button"
            onClick={handleMoveToBuilder}
            className="w-full flex-1 py-3 font-semibold rounded-xl border border-blue-600 text-blue-600 bg-white hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
          >
            전체 일정표 보기
          </button>

        </div>
      </div>
      
    </div>
  );
}